'use client';

import { IconMessage2, IconShare } from '@tabler/icons-react';
import {
  Button,
  Flex,
  Group,
  Image,
  Paper,
  Skeleton,
  Text,
} from '@mantine/core';
import { useRedirectCustomerChat } from '@/src/app/(b2c)/chat/_hooks/use-redirect-customer-chat';
import useModuleOutlet from '@/src/modules/marketplace/outlet';

export function OutletHeader() {
  const { outlet, handleShare } = useModuleOutlet();
  const {
    redirectSeller: reditectToCustomerChatWithSeller,
    isCreatingCustomerConversationWithSeller,
  } = useRedirectCustomerChat({
    branchId: outlet?.branch_id || null,
    branchUserPhoneNumber: outlet?.phone_number || null,
  });

  return (
    <Paper bdrs="1rem 1rem 0 0" p="md" className="bg-white">
      <Group align="flex-start" wrap="nowrap">
        <Image
          src={outlet?.branch_logo}
          w={80}
          h={80}
          fit="contain"
          alt={outlet?.branch_name}
          radius="md"
          fallbackSrc="/images/logo.png"
          className="border border-gray-100"
        />

        <Flex
          gap="xs"
          justify="space-between"
          w="100%"
          direction={{
            base: 'column',
            lg: 'row',
          }}
        >
          <Group justify="space-between" align="flex-start" wrap="nowrap">
            <div>
              <Group gap="xs" align="center" mb={4}>
                {!outlet?.branch_name || !outlet?.branch_point_name ? (
                  <Skeleton height={30} width={400} radius="sm" />
                ) : (
                  <Text fw={700} size="lg" className="text-gray-900">
                    {`${outlet?.branch_name} - ${outlet?.branch_point_name}`}
                  </Text>
                )}
              </Group>

              {/*<Text
                size="sm"
                c="dimmed"
                mb={8}
              >
                {outlet?.address}
                (± 3,64 KM)
              </Text>*/}

              {/* <Group gap="xs" align="center">
                                <Rating value={4.9} readOnly size="xs" count={1} />
                                <Text size="sm" fw={500}>4.9</Text>
                                <Text size="sm" c="dimmed">(5032 Rating | 304 Ulasan)</Text>
                            </Group> */}
            </div>
          </Group>

          {/* Action Buttons */}
          {/*<div className="mt-4 flex flex-row gap-2">
            <Button
              variant="outline"
              color="brand.5"
              radius="md"
              fullWidth
              className="sm:w-auto"
              leftSection={<IconMessage size={18} />}
            >
              Kirim Pesan
            </Button>

            <Button
              variant="filled"
              color="brand.5"
              radius="md"
              fullWidth
              className="sm:w-auto"
              leftSection={<IconPlus size={18} />}
            >
              Ikuti
            </Button>
          </div>*/}

          <Group gap="xs">
            <Button
              size="xs"
              onClick={reditectToCustomerChatWithSeller}
              loading={isCreatingCustomerConversationWithSeller}
            >
              <Group gap="xs">
                <IconMessage2 size={18} />
                Chat Penjual
              </Group>
            </Button>

            <Button
              variant="default"
              radius="md"
              className="w-fit!"
              onClick={handleShare}
              size="xs"
            >
              <Group gap="xs">
                <IconShare size={18} />
                <Text visibleFrom="lg" fz="sm">
                  Bagikan
                </Text>
              </Group>
            </Button>
          </Group>
        </Flex>
      </Group>
    </Paper>
  );
}
